module.exports = __webpack_public_path__ + "static/img/xwq.142374c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xwq.png
// module id = ZDJz
// module chunks = 0